var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7806 0C21.9678 0 22.9303 0.962461 22.9303 2.14972V15.0486C22.9303 16.2358 21.9678 17.1983 20.7806 17.1983H2.14972C0.962461 17.1983 0 16.2358 0 15.0486V2.14972C0 0.962461 0.962461 0 2.14972 0H20.7806ZM11.4628 3.46028C11.2726 3.46028 11.0903 3.53598 10.9559 3.67051L7.85076 6.77993C7.57116 7.05996 7.57147 7.5137 7.85153 7.79335C8.13156 8.073 8.5853 8.07272 8.86486 7.79268L10.7464 5.90848V13.0217C10.7464 13.4174 11.0672 13.7382 11.463 13.7382C11.8587 13.7382 12.1795 13.4174 12.1795 13.0217V5.90686L14.0657 7.79297C14.3456 8.07281 14.7993 8.07281 15.0792 7.79297C15.359 7.51312 15.359 7.05949 15.0792 6.77964L11.9697 3.67016C11.8352 3.53572 11.6529 3.46028 11.4628 3.46028Z",
    fill: "#818090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareScreen);
export default __webpack_public_path__ + "static/media/shareScreen.25f3d94583333668f3e161a6fb80e3ab.svg";
export { ForwardRef as ReactComponent };